import { Link, Navigate, useNavigate, useLocation } from "react-router-dom"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { Button } from "react-bootstrap"
import {
  IconAlertCircle,
  IconArrowLeft,
} from "../../components/utils/Icons/CustomIcons"
import "react-toastify/dist/ReactToastify.css"
import { useAppDispatch, useAppSelector } from "../../redux/store"
import { loginPhoneStepOne, setError } from "../../redux/slices/auth/authSlice"
import { getPovSubscription } from "@/redux/slices/payments/paymentsSlices"
import { logoutUser } from "@/redux/slices/auth/authSlice"
import { setLanguage } from "@/redux/slices/auth/authSlice"
import { FaWhatsapp } from "react-icons/fa"
import { CiAt } from "react-icons/ci"
import { TbWorldWww } from "react-icons/tb"
import { IoChevronDownSharp } from "react-icons/io5"
import { z } from "zod"
import { zodResolver } from "@hookform/resolvers/zod"
import Eye from "./Eye"
import { useForm } from "react-hook-form"
import Spinner from "react-bootstrap/Spinner"
import api from "@/api/api"
import { toast } from "react-toastify"
import { MdEdit } from "react-icons/md"
import { IoCloseSharp } from "react-icons/io5"

// Define schema with zod
const schema = z
  .object({
    oldPassword: z.string().min(8, " password must be at least 8 characters"),
    newPassword: z.string().min(8, " password must be at least 8 characters"),
    confirmPassword: z
      .string()
      .min(8, " password must be at least 8 characters"),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    path: ["confirmPassword"],
    message: "Passwords do not match",
  })

type FormData = z.infer<typeof schema>

const findLatestEntitlement = (entitlements: any) => {
  const entitlementList = Object.values(entitlements)
  return entitlementList.reduce((latest: any, current: any) => {
    return new Date(current.purchase_date) > new Date(latest.purchase_date)
      ? current
      : latest
  })
}
const ProfilePage = () => {
  const [displayChangePassword, setDisplayChangePassword] = useState(false)

  const { lang, error, status, email, phone, first_name, last_name } =
    useAppSelector((state) => state.auth)
  const [showOldPassword, setShowOldPassword] = useState<boolean>(false)
  const [showNewPassword, setShowNewPassword] = useState<boolean>(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState<boolean>(false)
  const [loading, setLoading] = useState(false)
  const { currentPovPlan } = useAppSelector((state) => state?.payments)
  const navigate = useNavigate()
  const { t, i18n } = useTranslation()
  const location = useLocation()
  const dispatch = useAppDispatch()
  const [langs, setLang] = useState(t("header.language2"))
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormData>({
    resolver: zodResolver(schema),
  })
  const onSubmit = async (data: FormData) => {
    console.log("Form Data: ", data)
    try {
      setLoading(true)
      const formateData = {
        confirmPassword: data?.confirmPassword,
        old_password: data?.oldPassword,
        password: data?.newPassword,
      }
      const updatedPassWord = await api.auth.profile(formateData)
      setLoading(false)

      if (updatedPassWord?.status == 200) {
        toast.success("Password updated successfully")
        navigate("/")
      }
      console.log("updatedPassWord", updatedPassWord)
    } catch (err: any) {
      const message = err?.response.data.message
      toast.error(message ? message : "Password not changed, try again later")
      setLoading(false)

      console.log("error", err)
    }
  }
  const changeLanguage = (language: string) => {
    let html = document.querySelector("html") || null
    i18n.changeLanguage(language)

    switch (language) {
      case "ar":
        html?.setAttribute("dir", "rtl")
        break
      default:
        html?.setAttribute("dir", "ltl")
        break
    }
    dispatch(setLanguage(language))
    setLang(language)
  }

  useEffect(() => {
    if (email) {
      dispatch(getPovSubscription(email ? email : phone ? phone : ""))
    }
  }, [email, phone])

  return (
    <div className=" container profile-section" style={{ minHeight: "100vh" }}>
      <div className="container container-profile">
        <div className="mb-4 " style={{ width: "80px", marginLeft: "-20px" }}>
          <Button
            className="d-flex align-items-center "
            style={{
              backgroundColor: "transparent",
              border: "none",
              color: "black",
              fontSize: "18px",
              textDecoration: "none",
              textTransform: "none",
            }}
            onClick={() => navigate(-1)}
          >
            <IconArrowLeft />
            <span className="reminders-page__link-text">
              {t("buttons.backNew")}
            </span>
          </Button>
        </div>{" "}
      </div>
      <h4 className="d-flex justify-content-start align-items-center mb-2 mb-4">
        {t("profile.settings")}
      </h4>

      <div
        className=" p-2 gap-3  row  d-flex   "
        // style={{ backgroundColor: "#ffffff" }}
      >
        <div
          className="col-12 col-sm-8 col-md-8 col-lg-6  d-flex  flex-column gap-4 p-3 "
          style={{ backgroundColor: "#ffffff" }}
        >
          <h4
            className="fw-normal"
            style={{ color: "#000000", fontSize: "20px" }}
          >
            {t("profile.user")}
          </h4>
          <div className="d-flex flex-column gap-3 ">
            <div className="d-flex flex-row  justify-content-between   align-items-center   ">
              <h6> {t("profile.email")} :</h6>
              <h5>{email}</h5>
            </div>

            <div className="d-flex flex-row  justify-content-between   align-items-center   ">
              <h6>{t("profile.language")}</h6>

              <div className="d-flex ms-2 gap-0">
                <Button
                  style={{
                    backgroundColor: lang === "en" ? "#245192" : "#d7d6d6",
                    // backgroundColor:"#245192",

                    color: lang === "en" ? "white" : "black",
                    border: "none",
                    borderRadius: "5px 0 0 5px", // rounded left corner
                    padding: "10px 20px", // Adjust padding as needed
                  }}
                  onClick={() => changeLanguage("en")}
                >
                  {t("header.language2")}
                </Button>
                <Button
                  type="submit"
                  style={{
                    backgroundColor: lang === "ar" ? "#245192" : "#d7d6d6",
                    // backgroundColor: "#245192",

                    color: lang === "ar" ? "white" : "black",
                    border: "none",
                    borderRadius: "0 5px 5px 0", // rounded right corner
                    padding: "10px 20px", // Adjust padding as needed
                  }}
                  onClick={() => changeLanguage("ar")}
                >
                  {t("header.language1")}
                </Button>
              </div>
            </div>
          </div>
        </div>

        <div
          className="col-12 col-sm-8 col-md-8 col-lg-6  d-flex  flex-column p-4 "
          style={{ backgroundColor: "#ffffff" }}
        >
          <div className="d-flex justify-content-between align-items-center gap-4">
            <h4
              className="fw-normal"
              style={{ color: "#000000", fontSize: "18px" }}
            >
              {/* Password */}
              {t("changePassword.password")}
            </h4>
            <div>
              {!displayChangePassword && (
                <Button
                  onClick={() =>
                    setDisplayChangePassword(!displayChangePassword)
                  }
                  style={{
                    backgroundColor: "#245192",
                    color: "white",
                    border: "none",
                    width: "200px",
                    justifyContent: "center",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <MdEdit />{" "}
                  <span className="ms-2"> {t("changePassword.title")}</span>
                </Button>
              )}
              {displayChangePassword && (
                <Button
                  onClick={() =>
                    setDisplayChangePassword(!displayChangePassword)
                  }
                  style={{
                    backgroundColor: "#245192",
                    color: "white",
                    border: "none",
                    width: "200px",
                    justifyContent: "center",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <IoCloseSharp style={{ fontSize: "20px" }} />
                  <span className="ms-2"> {t("buttons.cancel")}</span>
                </Button>
              )}
            </div>
          </div>
          {displayChangePassword && (
            <form
              onSubmit={handleSubmit(onSubmit)}
              className="space-y-4 mt-4  d-flex flex-column gap-3"
            >
              {/* <h6 className="fs-5"></h6> */}
              {/* <h4
                className="fw-normal"
                style={{ color: "#000000", fontSize: "18px" }}
              >
                Change password
              </h4> */}
              {/* {t("profile.plan")} */}

              {/* Old Password Field */}
              <div>
                <div
                  className="ps-2 pe-2"
                  style={{
                    position: "relative",
                    width: "100%",
                    maxWidth: "320px",
                    color: "#212121",
                    backgroundColor: "white",
                    border: "1px solid black",
                    borderRadius: "5px",
                  }}
                  // className={`d-flex p-0 w-full border-none ${
                  //   errors.oldPassword ? "border-red-500" : "border-gray-300"
                  // }`}
                >
                  {/* Input Field */}

                  <input
                    id="oldPassword"
                    type={showOldPassword ? "text" : "password"}
                    placeholder={t("changePassword.oldPassword")}
                    {...register("oldPassword")}
                    style={{
                      color: "#212121",
                      fontSize: "1rem",
                      backgroundColor: "white",
                      borderRadius: "4px",
                      paddingRight: "40px", // Space for the icon
                      border: "none",
                      outline: "none", // Prevent border on focus
                    }}
                    className=" w-full border-none"
                  />
                  <Eye
                    setIsVisiblePassword={setShowOldPassword}
                    isVisiblePassword={showOldPassword}
                  />
                </div>
                {errors.oldPassword && (
                  <small
                    className=" "
                    style={{ color: "red", fontSize: "15px" }}
                  >
                    {errors.oldPassword.message}
                  </small>
                )}
              </div>
              <div>
                <div
                  className="ps-2 pe-2"
                  style={{
                    position: "relative",
                    width: "100%",
                    maxWidth: "320px",
                    color: "#212121",
                    backgroundColor: "white",
                    border: "1px solid black",
                    borderRadius: "5px",
                  }}
                  // className={`d-flex p-0 w-full border-none ${
                  //   errors.oldPassword ? "border-red-500" : "border-gray-300"
                  // }`}
                >
                  {/* Input Field */}
                  <input
                    id="newPassword"
                    type={showNewPassword ? "text" : "password"}
                    placeholder={t("changePassword.new")}
                    {...register("newPassword")}
                    style={{
                      color: "#212121",
                      fontSize: "1rem",
                      backgroundColor: "white",
                      borderRadius: "4px",
                      paddingRight: "40px", // Space for the icon
                      border: "none",
                      outline: "none", // Prevent border on focus
                    }}
                    className=" w-full border-none"
                  />
                  <Eye
                    setIsVisiblePassword={setShowNewPassword}
                    isVisiblePassword={showNewPassword}
                  />
                </div>
                {errors.newPassword && (
                  <small
                    className=" "
                    style={{ color: "red", fontSize: "15px" }}
                  >
                    {errors.newPassword.message}
                  </small>
                )}
              </div>
              <div>
                <div
                  className="ps-2 pe-2"
                  style={{
                    position: "relative",
                    width: "100%",
                    maxWidth: "320px",
                    color: "#212121",
                    backgroundColor: "white",
                    border: "1px solid black",
                    borderRadius: "5px",
                  }}
                  // className={`d-flex p-0 w-full border-none ${
                  //   errors.oldPassword ? "border-red-500" : "border-gray-300"
                  // }`}
                >
                  {/* Input Field */}
                  <input
                    id="confirmPassword"
                    type={showConfirmPassword ? "text" : "password"}
                    placeholder={t("changePassword.confirm")}
                    {...register("confirmPassword")}
                    style={{
                      color: "#212121",
                      fontSize: "1rem",
                      backgroundColor: "white",
                      borderRadius: "4px",
                      paddingRight: "40px", // Space for the icon
                      border: "none",
                      outline: "none", // Prevent border on focus
                    }}
                    className=" w-full border-none"
                  />
                  <Eye
                    setIsVisiblePassword={setShowConfirmPassword}
                    isVisiblePassword={showConfirmPassword}
                  />
                </div>
                {errors.confirmPassword && (
                  <small
                    className=" "
                    style={{ color: "red", fontSize: "15px" }}
                  >
                    {errors.confirmPassword.message}
                  </small>
                )}
              </div>

              {/* Submit Button */}
              {loading ? (
                <div
                  // className="d-flex justify-content-start align-items-start"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    maxWidth: "300px",
                    // height: "50vh",
                  }}
                >
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>
                </div>
              ) : (
                <Button
                  style={{
                    backgroundColor: "#245192",
                    color: "white",
                    maxWidth: "320px",
                  }}
                  type="submit"
                >
                  {t("buttons.save")}
                </Button>
              )}
            </form>
          )}
        </div>
        <div
          className="col-12 col-sm-8 col-md-8 col-lg-6 d-flex  flex-row  justify-content-between gap-4 p-3 "
          style={{ backgroundColor: "#ffffff" }}
        >
          <h4
            className="fw-normal"
            style={{ color: "#000000", fontSize: "18px" }}
          >
            {t("profile.plan")}
          </h4>
          {/* <h4
            className="fw-normal"
            style={{ color: "#000000", fontSize: "17px" }}
          >
            Basic Plan
          </h4> */}
          <h4 className="fw-normal" style={{ fontSize: "18px" }}>
            {/* Basic Plan */}
            {currentPovPlan === "basic_plan" && t("profile.basicPlan")}
            {currentPovPlan === "pro_plan" && t("profile.proPlan")}
            {currentPovPlan === "unlimited_plan" && t("profile.unlimitedPlan")}
          </h4>
        </div>

        <div
          className="col-12 col-sm-8 col-md-8 col-lg-6 d-flex  flex-column gap-4 p-3 "
          style={{ backgroundColor: "#ffffff" }}
        >
          <h4
            className="fw-normal"
            style={{ color: "#000000", fontSize: "18px" }}
          >
            {t("profile.contactUs")}
          </h4>
          <div className="d-flex flex-column gap-3 ">
            <Link
              to="/#"
              className="header-nav__link d-flex flex-row align-items-center gap-2 mt-2 text-decoration-none"
            >
              {/* <span className="header-nav__text"> */}{" "}
              <FaWhatsapp
                style={{
                  color: "green",
                  fontSize: "20px",
                  marginTop: "2x",
                }}
              />{" "}
              <h5 className="d-flex fw-normal" style={{ fontSize: "1rem" }}>
                +966 505 252 278 757
              </h5>
              {/* </span> */}
            </Link>
            <Link
              to="/#"
              className="header-nav__link d-flex flex-row align-items-center gap-2 mt-2 text-decoration-none"
            >
              {/* <span className="header-nav__text"> */}{" "}
              <CiAt
                style={{
                  color: "#20529B",
                  fontSize: "20px",
                  marginTop: "2x",
                }}
              />{" "}
              <h5
                className="d-flex fw-normal"
                style={{ fontSize: "1rem", textTransform: "none" }}
              >
                invitesmartapp@gmail.com
              </h5>
              {/* </span> */}
            </Link>
            <Link
              to="https://www.invitesmartapp.com/"
              target="_blank"
              className="header-nav__link d-flex flex-row align-items-center gap-2 mt-2 text-decoration-none"
            >
              {/* <span className="header-nav__text"> */}{" "}
              <TbWorldWww
                style={{
                  color: "#20529B",
                  fontSize: "20px",
                  marginTop: "2x",
                }}
              />{" "}
              <h5
                className="d-flex fw-normal"
                style={{ fontSize: "1rem", textTransform: "none" }}
              >
                www.invitesmartapp.com
              </h5>
              {/* </span> */}
            </Link>
          </div>
        </div>

        <div
          className="col-12 col-sm-8 col-md-8 col-lg-6 d-flex  flex-column gap-4 p-3 "
          style={{ backgroundColor: "#ffffff" }}
        >
          {" "}
          <Button
            style={{
              backgroundColor: "red",
              color: "#ffffff",
              border: "none",
              // width: "300px",
            }}
            className="mt-2"
            onClick={() => {
              dispatch(logoutUser())
            }}
          >
            {t("profile.logout")}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default ProfilePage
